import { render, staticRenderFns } from "./HotelManAllDetail.vue?vue&type=template&id=4a454f86&scoped=true"
import script from "./HotelManAllDetail.vue?vue&type=script&lang=js"
export * from "./HotelManAllDetail.vue?vue&type=script&lang=js"
import style0 from "./HotelManAllDetail.vue?vue&type=style&index=0&id=4a454f86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a454f86",
  null
  
)

export default component.exports